<template>
	<div class="ripple-container lightBg" :class="{ lightBg: isLight }" :style="style">
		<div class="ripple"></div>
		<div class="ripple"></div>
		<div class="ripple"></div>
		<div class="ripple"></div>
	</div>
</template>

<script>
export default {
	props: {
		isLight: {
			type: Boolean,
			default: false,
		},
		width: {
			type: Number,
			default: 24,
		},
	},
	computed: {
		style() {
			return {
				width: `${this.width}px`,
				height: `${this.width}px`,
			};
		},
	},
};
</script>

<style scoped>
.lightBg {
	background: #f0edff;
}
.ripple-container {
	position: relative;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.ripple {
	position: absolute;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #7052ff;
	animation: ripple 2s infinite;
}

.ripple:nth-child(1) {
	animation-delay: 0s;
}

.ripple:nth-child(2) {
	animation-delay: 0.5s;
}

.ripple:nth-child(3) {
	animation-delay: 1s;
}
.ripple:nth-child(4) {
	animation-delay: 1.5s;
}

@keyframes ripple {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	100% {
		transform: scale(3);
		opacity: 0;
	}
}
</style>
